/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Keep_Vo_TracksInputs */

const en_audio_description_export_keep_vo_tracks = /** @type {(inputs: Audio_Description_Export_Keep_Vo_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export VO Track(s)`)
};

const fr_audio_description_export_keep_vo_tracks = /** @type {(inputs: Audio_Description_Export_Keep_Vo_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter la ou les pistes VO`)
};

const de_audio_description_export_keep_vo_tracks = /** @type {(inputs: Audio_Description_Export_Keep_Vo_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VO-Spur(en) exportieren`)
};

const it_audio_description_export_keep_vo_tracks = /** @type {(inputs: Audio_Description_Export_Keep_Vo_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta tracce VO`)
};

const ru_audio_description_export_keep_vo_tracks = /** @type {(inputs: Audio_Description_Export_Keep_Vo_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт аудиодорожек`)
};

const es_audio_description_export_keep_vo_tracks = /** @type {(inputs: Audio_Description_Export_Keep_Vo_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar pistas VO`)
};

const zh_cn2_audio_description_export_keep_vo_tracks = /** @type {(inputs: Audio_Description_Export_Keep_Vo_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出配音轨道`)
};

const ja_audio_description_export_keep_vo_tracks = /** @type {(inputs: Audio_Description_Export_Keep_Vo_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VOトラックをエクスポート`)
};

const hi_audio_description_export_keep_vo_tracks = /** @type {(inputs: Audio_Description_Export_Keep_Vo_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वॉयस ओवर ट्रैक निर्यात करें`)
};

const pt_pt2_audio_description_export_keep_vo_tracks = /** @type {(inputs: Audio_Description_Export_Keep_Vo_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar faixa(s) de narração`)
};

/**
* | output |
* | --- |
* | "Export VO Track(s)" |
*
* @param {Audio_Description_Export_Keep_Vo_TracksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_keep_vo_tracks = /** @type {((inputs?: Audio_Description_Export_Keep_Vo_TracksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Keep_Vo_TracksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_keep_vo_tracks(inputs)
	if (locale === "de") return de_audio_description_export_keep_vo_tracks(inputs)
	if (locale === "it") return it_audio_description_export_keep_vo_tracks(inputs)
	if (locale === "ru") return ru_audio_description_export_keep_vo_tracks(inputs)
	if (locale === "es") return es_audio_description_export_keep_vo_tracks(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_keep_vo_tracks(inputs)
	if (locale === "ja") return ja_audio_description_export_keep_vo_tracks(inputs)
	if (locale === "hi") return hi_audio_description_export_keep_vo_tracks(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_keep_vo_tracks(inputs)
	return en_audio_description_export_keep_vo_tracks(inputs)
});